<div class="row fill-screen">
  <app-skills (skillAddedEvent)="onSkillAdded($event)"
              (skillLevelChangedEvent)="onSkillLevelChanged($event)"
              (skillRemovedEvent)="onSkillRemoved($event)"
              (lavishUpdatedEvent)="onLavishUpdated($event)"
              (tableAddedEvent)="onTableAdded($event)"
              (tableRemovedEvent)="onTableRemoved($event)"
              (upgradeChangedEvent)="onUpgradeChanged($event)"
              class="col bg-dark-elevated-2 col-border bottom-padding">
  </app-skills>
  <app-ingredients (ingredientPriceChangedEvent)="onIngredientPriceChanged($event)"
                   (laborCostChangedEvent)="onLaborCostChanged($event)"
                   (profitPercentChangedEvent)="onProfitPercentChanged($event)"
                   class="col bg-dark-elevated-2 col-border bottom-padding">
  </app-ingredients>
  <app-outputs (itemRemovedEvent)="onItemRemoved($event)"
               (recipeAddedEvent)="onRecipeAdded($event)"
               (subRecipeRemovedEvent)="onSubRecipeRemoved($event)"
               class="col-5 bg-dark-elevated-2 col-border bottom-padding">
  </app-outputs>
</div>
